import type { ErrorEvent, EventHint } from "@sentry/nextjs";
import * as Sentry from "@sentry/nextjs";

// Production builds replace server error messages with a generic "An error
// occurred in the Server Components render..." and keep only a `digest`. The
// server-side event for the same failure carries the same digest, so tagging
// it lets `digest:<value>` in Sentry link the opaque client error to the real
// one. Next.js control-flow errors have readable digests, e.g.
// `NEXT_HTTP_ERROR_FALLBACK;404` for notFound().
export function tagErrorDigest(event: ErrorEvent, hint: EventHint) {
  const error = hint.originalException;
  if (
    error instanceof Error &&
    "digest" in error &&
    typeof error.digest === "string"
  ) {
    event.tags = { ...event.tags, digest: error.digest };
  }
  return event;
}

export function setUserToSentry({
  userId,
  email,
}: {
  userId?: string | null;
  email?: string;
}) {
  Sentry.setUser({ id: userId || undefined, email: email });
}
